<!--
 * @Author: 罗川平 2150673512@qq.com
 * @Date: 2025-08-05 14:20:17
 * @LastEditors: 罗川平 2150673512@qq.com
 * @LastEditTime: 2025-08-08 11:31:45
 * @FilePath: \member_ship\src\views\addswap.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="addswappage">
    <div class="headerBox">
      <div class="backBtnBox" @click="backpage">
        <i class="el-icon-arrow-left"></i>
      </div>发布信息
    </div>
    <div class="mainbox">
      <van-form @submit="onSubmit">
        <van-field
          v-model="username"
          label="用户名称"
          placeholder="用户名称"
          :rules="[{ required: true, message: '请填写用户名' }]"
        ></van-field>
        <van-field
          v-model="type"
          label="发布类型"
          placeholder="个人标签"
          @focus="openMybox"
          :rules="[{ required: true, message: '请选择类型' }]"
        ></van-field>
        <van-field
          v-model="Hangye"
          label="行业"
          placeholder="行业"
          :rules="[{ required: true, message: '请填写行业' }]"
        ></van-field>
        <van-field
          v-model="Price"
          label="预算"
          placeholder="预算"
        
        ></van-field>

        <van-field
          v-model="Title"
          name="信息标题"
          label="信息标题"
          maxlength="500"
          placeholder="请输入信息的标题"
          :rules="[{ required: true, message: '请填写信息标题' }]"
        />
        <van-field
          v-model="Content"
          rows="10"
          autosize
          
          label="信息内容"
          type="textarea"
          maxlength="500"
          placeholder="请输入信息内容"
          show-word-limit
          :rules="[{ required: true, message: '请填写信息内容' }]"
        />
        <van-cell title="头像图片">
          <template #label>
            <van-image width="100" height="100" :src="macPhoto">
              <template v-slot:error>未上传</template>
            </van-image>
          </template>
          <template #default>
            <el-upload
              style="margin-left:20px"
              class="upload-demo"
              action="https://www.moodsci.com/pigbox/CommodityService/uploadGoodsPicture"
              :auto-upload="true"
              multiple
              :on-success="fileDataChange2"
              :show-file-list="false"
              :limit="1"
            >
              <el-button size="mini" type="primary">上传图片</el-button>
            </el-upload>
          </template>
        </van-cell>
        <!-- <van-cell title="附件">
          <template #default>
            <el-upload
              style="margin-left:20px"
              class="upload-demo"
              action="https://www.moodsci.com/pigbox/CommodityService/uploadGoodsPicture"
              :auto-upload="true"
              multiple
              :on-success="fileDataChange2"
              :show-file-list="false"
              :limit="1"
            >
              <el-button size="mini" type="primary">上传附件</el-button>
            </el-upload>
          </template>
        
        </van-cell> -->
        <div style="margin: 16px;">
          <van-button round block type="info" native-type="submit">提交</van-button>
        </div>
      </van-form>
    </div>
    <van-popup
      v-model="showPicker2"
      closeable
      position="bottom"
      @click-close-icon="popColose"
      @click-overlay="popColose"
    >
      <div style="height:40px"></div>
      <van-radio-group v-model="type">
        <van-cell-group>
          <van-cell v-for="(item, index) in tabList" clickable :key="item" :title="`${item}`">
            <template #right-icon>
              <van-radio :name="item" />
            </template>
          </van-cell>
        </van-cell-group>
      </van-radio-group>
    </van-popup>
  </div>
</template>

<script>
import { Notify } from 'vant';
export default {
  data() {
    return {
      Price: "",
      Hangye: "",
      username: "",
      macPhoto: "",
      Content: "",
      Title: "",
      type: "需求",
      showPicker2: false,
      tabList: ["需求", "招标", "招聘", "公告"]
    };
  },
  methods: {
    onSubmit() {
      if(this.Price==''){
        this.Price=0
      }
       let formData = new FormData();
    formData.append('params', `{"Data":[{"interfaceId":'saveDemand','Username':"${this.username}",'Hangye':"${this.Hangye}",'Price':"${this.Price}",'Title':"${this.Title}","Content":"${this.Content}","Type":"${this.type}","Img":"${this.macPhoto}"}]}`);
      this.$axios({
        method: "post",
        url: `https://www.moodsci.com/SWDataservice/release/saveDemand`, // 接口地址
        // url: `https://www.moodsci.com/SWDataservice/sxwshop/saveDemand`, // 接口地址
        data:formData
      }).then(res => {
        // console.log(res);
        Notify({ type: "success", message: "发布成功" });
      });
    },
    backpage() {
      this.$router.back();
    },
    fileDataChange2(e) {
      console.log(e);
      this.macPhoto = `https://www.moodsci.com${e}`;
    },
    openMybox() {
      this.showPicker2 = true;
    },
    popColose() {}
  }
};
</script>

<style>
.addswappage {
  /* hei */
  height: 100vh;
  width: 100vw;
  /* background-color: aqua; */
}
.headerBox {
  height: 50px;
  text-align: center;
  line-height: 50px;
  line-height: 50px;
}
.mainbox {
  height: calc(100vh - 50px);
  width: 100%;
}
.backBtnBox {
  height: 30px;
  width: 30px;
  position: absolute;
  left: 10px;
  font-size: 30px;
  /* top: 10px; */
}
</style>